function createAddToCartForm(sectionId, redirectButtonClasses, redirectButtonLink, redirectButtonText) {
    const priceButtonContainer = document.querySelector(`.${sectionId}-price-button`);
    if (priceButtonContainer.dataset.productInCart === 'true') {
        return;
    }

    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/en-gb/cart/add';
    form.id = 'product-form-template--24116462092561__main';
    form.acceptCharset = 'UTF-8';
    form.classList.add('form');
    form.enctype = 'multipart/form-data';
    form.setAttribute('novalidate', 'novalidate');
    form.setAttribute('data-type', 'add-to-cart-form');

    const inputs = [
        {type: 'hidden', name: 'form_type', value: 'product'},
        {type: 'hidden', name: 'utf8', value: '✓'},
        {type: 'hidden', name: 'id', value: '51264739344657', class: 'product-variant-id'},
        {type: 'hidden', name: 'product-id', value: '10338952151313'},
        {type: 'hidden', name: 'section-id', value: 'template--24116462092561__main'},
        {type: 'hidden', name: 'selling_plan', value: '12369232145'},
        {
            type: 'hidden',
            name: 'sections',
            value: 'cart-notification-product,cart-notification-button,cart-icon-bubble'
        },
        {type: 'hidden', name: 'sections_url', value: '/en-gb/products/world-of-books-plus-1'}
    ];

    for (const input of inputs) {
        const inputElement = document.createElement('input');
        Object.assign(inputElement, {type: input.type, name: input.name, value: input.value});
        if (input.class) {
            inputElement.classList.add(input.class);
        }
        form.appendChild(inputElement);
    }

    const formButtonsContainer = document.createElement('div');
    formButtonsContainer.classList.add('product-form__buttons');

    const addToCartButton = document.createElement('button');
    addToCartButton.id = 'ProductSubmitButton-template--24116462092561__main';
    addToCartButton.type = 'submit';
    addToCartButton.name = 'add';
    addToCartButton.classList.add('product-form__submit', 'button', 'button--fullwidth', 'button--primary', 'promo-button');
    Object.assign(addToCartButton.style, {
        background: 'var(--wob--yellow)',
        color: 'var(--wob--green-1)',
        width: '160px',
        marginBottom: '0'
    });

    const buttonTextSpan = document.createElement('span');
    buttonTextSpan.textContent = priceButtonContainer.dataset.buttonText;

    const loadingSpinnerContainer = document.createElement('div');
    loadingSpinnerContainer.classList.add('loading-overlay__spinner', 'hidden');

    const svgSpinner = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svgSpinner.setAttribute('aria-hidden', 'true');
    svgSpinner.setAttribute('focusable', 'false');
    svgSpinner.classList.add('spinner');
    svgSpinner.setAttribute('viewBox', '0 0 66 66');
    svgSpinner.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    const spinnerCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
    spinnerCircle.classList.add('path');
    spinnerCircle.setAttribute('fill', 'none');
    spinnerCircle.setAttribute('stroke-width', '6');
    spinnerCircle.setAttribute('cx', '33');
    spinnerCircle.setAttribute('cy', '33');
    spinnerCircle.setAttribute('r', '30');

    svgSpinner.appendChild(spinnerCircle);
    loadingSpinnerContainer.appendChild(svgSpinner);
    addToCartButton.appendChild(buttonTextSpan);
    addToCartButton.appendChild(loadingSpinnerContainer);
    formButtonsContainer.appendChild(addToCartButton);

    const errorMessageContainer = document.createElement('div');
    errorMessageContainer.classList.add('product-form__error-message-wrapper');
    errorMessageContainer.setAttribute('role', 'alert');
    errorMessageContainer.setAttribute('hidden', '');

    const errorIconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    errorIconSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    errorIconSvg.setAttribute('width', '24');
    errorIconSvg.setAttribute('height', '24');
    errorIconSvg.setAttribute('viewBox', '0 0 24 24');
    errorIconSvg.setAttribute('fill', 'none');

    const errorIconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    errorIconPath.setAttribute('d', 'M12 16H12.01M12 8V12M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z');
    errorIconPath.setAttribute('stroke', '#BD0000');
    errorIconPath.setAttribute('stroke-width', '2');
    errorIconPath.setAttribute('stroke-miterlimit', '3.8637');
    errorIconPath.setAttribute('stroke-linecap', 'square');

    errorIconSvg.appendChild(errorIconPath);
    errorMessageContainer.appendChild(errorIconSvg);

    const errorMessageText = document.createElement('span');
    errorMessageText.classList.add('product-form__error-message');
    errorMessageContainer.appendChild(errorMessageText);

    form.appendChild(formButtonsContainer);
    form.appendChild(errorMessageContainer);
    priceButtonContainer.appendChild(form);

    const changeAddToRedirectButton = () => {
        form.remove();
        const startShoppingButton = document.createElement('a');
        startShoppingButton.href = redirectButtonLink;
        startShoppingButton.classList.add(...redirectButtonClasses);
        startShoppingButton.textContent = redirectButtonText;
        priceButtonContainer.appendChild(startShoppingButton);
    };

    subscribe('membership-cta-clicked', changeAddToRedirectButton);

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        addToCartButton.disabled = true;
        const loadingSpinner = form.querySelector('.loading-overlay__spinner');
        loadingSpinner.classList.remove('hidden');
        buttonTextSpan.textContent = '';

        const formData = new FormData(form);

        fetch(form.action, {
            method: form.method,
            body: formData,
            headers: {
                'Accept': 'application/javascript',
                'Accept-Language': 'en-US,en;q=0.9,hu;q=0.8,da;q=0.7',
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'include'
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to add product to cart');
                }
                return response.json();
            })
            .then(data => {
                document.querySelector('cart-notification').renderContents(data);
            })
            .catch(() => {
            })
            .finally(() => {
                publish('membership-cta-clicked');
                addToCartButton.disabled = false;
                loadingSpinner.classList.add('hidden');
            });
    });
}